import { render, staticRenderFns } from "./goodsarea.vue?vue&type=template&id=e56f9326&scoped=true&"
import script from "./goodsarea.vue?vue&type=script&lang=js&"
export * from "./goodsarea.vue?vue&type=script&lang=js&"
import style0 from "./goodsarea.vue?vue&type=style&index=0&id=e56f9326&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56f9326",
  null
  
)

export default component.exports